import { buildUrl } from '../../utils/build-url'
import { fetchThrowsIfNotOk } from '../../utils/fetch-throws-if-not-ok'
import { z } from 'zod/v4'

export const AssistantBuilderZodSchema = z.object({
  title: z.string().describe('The name of the assistant'),
  description: z.string().describe('A description of the assistant'),
  customPrompt: z
    .string()
    .describe(
      "The prompt that will be used to generate the assistant's responses"
    ),
})

export type AssistantBuilderSchema = z.infer<typeof AssistantBuilderZodSchema>

export type AssistantBuilderOutput = {
  error?: string
  assistant?: AssistantBuilderSchema
}

export async function fetchSuperAssistantBuilder({
  baseUrl,
  token,
  userPrompt,
  digestMode,
}: {
  baseUrl: string
  token: string
  userPrompt: string
  digestMode: boolean
}): Promise<AssistantBuilderOutput> {
  const req = await fetchThrowsIfNotOk(
    buildUrl(baseUrl, '/generate-super-assistant'),
    {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userPrompt,
        digestMode,
      }),
    }
  )

  const result = (await req.json()) as AssistantBuilderOutput

  return result
}
